import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { NavBar } from './Navbar/Navbar'
import './layout.css';
import { Footer } from './Footer/Footer';
import { Home } from '../Pages/Home/Home';
import { Breadcrumb } from '../components/Brodcrumb/Breadcrumb';
import Login from '../Pages/Login/Login';
import UserRegister from '../Pages/Register/UserRegister';
import UserPage from '../Pages/UserPage/UserPage';
import {Historia} from '../Pages/historia/Historia';
import {ComisionDirectiva} from '../Pages/Comision/ComisionDirectiva'

export const LayoutPrincipal: React.FC = () => {
  return (
    <>
        <BrowserRouter>        
            <NavBar/> 
            <Breadcrumb/>
            <Routes>
                <Route path="/" element={<Home />} /> 
                <Route path="/historia" element={<Historia />} /> 
                <Route path="/comision" element={<ComisionDirectiva />} /> 
                {/* <Route path="/logros" element={<Logros />} />  */}
                {/* <Route path="/equipo" element={<Equito />} />  */}
                <Route path="/login" element={<Login />} /> 
                <Route path="/administrar" element={<UserPage/>} /> 
                <Route path="/registrar" element={<UserRegister/>} /> 
            </Routes>
        </BrowserRouter>            
        <Footer/>
    </>
  )
}
